class CustomForm extends HTMLElement {
  constructor() {
    super();
    this.endpoint = this.getAttribute('action') || this.dataset.endpoint || '/';
    this.successMessage = this.getAttribute('success-message') || 'הטופס נשלח בהצלחה!';
    this.errorMessage = this.getAttribute('error-message') || 'אירעה שגיאה, נסו שוב.';
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.responseEl = this.querySelector('.form-response');
    this.submitBtn = this.form.querySelector('button[type="submit"]');

    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.toggleLoading(true);
    const formData = new FormData(this.form);

    try {
      const res = await fetch(this.endpoint, {
        method: 'POST',
        body: formData,
      });

      if (!res.ok) throw new Error(await res.text());

      let data = {};
      try {
        data = await res.json();
      } catch {
      }

      this.showResponse(this.successMessage, 'success');
      this.form.reset();
    } catch (err) {
      console.error('[CustomForm] Submission failed:', err);
      this.showResponse(this.errorMessage, 'danger');
    } finally {
      this.toggleLoading(false);
    }
  }

  toggleLoading(isLoading) {
    if (!this.submitBtn) return;
    if (isLoading) {
      this.submitBtn.disabled = true;
      this.submitBtn.dataset.originalText = this.submitBtn.textContent;
      this.submitBtn.textContent = 'שולח...';
    } else {
      this.submitBtn.disabled = false;
      if (this.submitBtn.dataset.originalText) {
        this.submitBtn.textContent = this.submitBtn.dataset.originalText;
      }
    }
  }

  showResponse(message, type = 'success') {
    if (!this.responseEl) return;
    this.responseEl.textContent = message;
    this.responseEl.classList.remove('d-none', 'text-success', 'text-danger');
    this.responseEl.classList.add(type === 'success' ? 'text-success' : 'text-danger');
  }
}

customElements.define('custom-form', CustomForm);
